import { motion, stagger } from 'motion/react'

import { Skeleton } from '../ui/skeleton'

export const GenericListSkeleton = ({
  rowHeight = 80,
  rows = 6,
}: {
  rowHeight?: number
  rows?: number
}) => {
  return (
    <motion.div
      animate="show"
      className="flex flex-col gap-4"
      exit="exit"
      initial="hidden"
      variants={{
        hidden: {},
        show: {
          transition: { delayChildren: stagger(0.05) },
        },
      }}
    >
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton
          key={i}
          style={{ height: rowHeight, width: '100%' }}
          variants={{
            hidden: { opacity: 0, y: 40 },
            show: {
              opacity: 1,
              transition: {
                duration: 0.18,
                ease: 'easeOut',
              },
              y: 0,
            },
          }}
        />
      ))}
    </motion.div>
  )
}
